<template>
  <div class="section-h">
    <h3 v-if="isHallOfFame" class="is-size-3 is-uppercase is-underlined">{{endpoint.title}}</h3>
    <h3 v-else class="is-size-3 is-uppercase is-underlined">Awards &amp; Recognition</h3>
    <div class="level is-mobile filter-sort push push-extra" v-if="!isLoading">
      <div class="flex-column-center">
        <label class="is-uppercase" for="sort">Sorting by:</label>
        <select name="sort" class="button is-outlined is-radiusless is-uppercase is-size-6" v-model="sort">
          <option value="name">name</option>
          <option value="year">year</option>
          <option value="sport" v-if="this.honorees.results[0].sports.length">sport</option>
        </select>
      </div>
      <div>
        <a class="button is-outlined is-radiusless" @click="ascending = !ascending">
          <svg width="18.5" height="10.3" viewBox="0 0 18.5 10.3">
            <path d="M9.3,0,8.2.9,0,7.9l2,2.4L9.3,4.1l7.2,6.2,2-2.4L10.3.9Z" :class="{active: !ascending}" />
          </svg>
          <svg width="18.5" height="10.3" viewBox="0 0 18.5 10.3">
            <path d="M9.3,10.3l1-.9,8.2-7.1L16.5,0,9.3,6.2,2,0,0,2.4,8.2,9.5Z" :class="{active: ascending}" />
          </svg>
        </a>
      </div>
    </div>
    <spinner v-if="isLoading"></spinner>
    <div class="table-wrap push push-extra space" v-else>
      <div v-if="!isHallOfFame" class="award-header space-h">
        <p class="is-uppercase is-size-5">{{endpoint.title}}</p>
      </div>
      <table class="table table is-fullwidth is-striped">
        <tbody>
          <tr v-for="honoree in sortedHonorees" :key="honoree.id">
            <router-link 
              class="is-size-5 has-text-white"
              v-if="honoree.biography || honoree.photos.length || honoree.videos.length" 
              :to="{name:'honoree-detail',params:{honor:endpoint.slug,id:honoree.id}}">
              <td>{{honoree.first_name}} {{honoree.last_name}}</td>
              <td>{{honoree.year}}</td>
              <td v-if="honoree.sports.length"><span v-for="(sport, idx) in honoree.sports" :key="sport.id">{{sport.name}}<span v-if="idx != honoree.sports.length - 1">, </span></span></td>
            </router-link>
            <span v-else class="tr is-size-5 has-text-white">
              <td>{{honoree.first_name}} {{honoree.last_name}}</td>
              <td>{{honoree.year}}</td>
              <td v-if="honoree.sports.length"><span v-for="(sport, idx) in honoree.sports" :key="sport.id">{{sport.name}}<span v-if="idx != honoree.sports.length - 1">, </span></span></td>              
            </span>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!isHallOfFame" class="back flex-center is-bordered push push-extra" @click="$router.push('/all-honorees')">
      <p class="is-uppercase is-size-6">Back to awards &amp; recognition list</p>
    </div>
    <app-nav></app-nav>
  </div>
</template>

<script>
import Endpoints from '@/components/Endpoints.js';

export default {
  data() {
    return {
      endpoint: Endpoints.List.find(
        obj => obj.slug === this.$route.params.honor
      ),
      ascending: true,
      sort: 'name'
    };
  },
  computed: {
    isHallOfFame() {
      return this.$router.currentRoute.path.indexOf('hall-of-fame') != -1;
    },
    isLoading() {
      return this.$store.state.pending[this.endpoint.listProperty];
    },
    sortedHonorees() {
      if (this.sort === 'name') {
        if (this.ascending) {
          return this.honorees.results.sort((a, b) => {
            if (a.last_name > b.last_name) {
              return 1;
            } else {
              return -1;
            }
            return 0;
          });
        } else {
          return this.honorees.results.sort((a, b) => {
            if (a.last_name > b.last_name) {
              return -1;
            } else {
              return 1;
            }
            return 0;
          });
        }
      } else if (this.sort === 'year') {
        if (this.ascending) {
          return this.honorees.results.sort((a, b) => {
            if (a.year > b.year) {
              return 1;
            } else {
              return -1;
            }
            return 0;
          });
        } else {
          return this.honorees.results.sort((a, b) => {
            if (a.year > b.year) {
              return -1;
            } else {
              return 1;
            }
            return 0;
          });
        }
      } else {
        if (this.ascending) {
          return this.honorees.results.sort((a, b) => {
            if (a.sports[0].name > b.sports[0].name) {
              return 1;
            } else {
              return -1;
            }
            return 0;
          });          
        } else {
          return this.honorees.results.sort((a, b) => {
            if (a.sports[0].name > b.sports[0].name) {
              return -1;
            } else {
              return 1;
            }
            return 0;
          }); 
        }
      }    
    },
    honorees() {
      return this.$store.state[this.endpoint.listProperty];
    }
  },
  created() {
    this.$store.dispatch(this.endpoint.listAction);
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

svg {
  margin: 0 2px;
  path {
    fill: #818181;
    transition: fill 0.2s linear;
    &.active {
      fill: $blue;
    }
  }
}
select {
  color: #808080;
  background-color: #fff;
}
.award-header {
  display: flex;
  align-items: center;
  height: 50px;
  width: 95%;
  background-color: $gold;
  -webkit-clip-path: polygon(0 0, 100% 0, 87% 100%, 0% 100%);
  clip-path: polygon(0 0, 100% 0, 94% 100%, 0% 100%);
  p {
    color: $blue;
    font-family: 'DIN Next LT Pro M';
    line-height: 1.2rem;
  }
}
.table-wrap {
  height: 500px;
  overflow-y: auto;
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 2%,
    rgba(0, 0, 0, 0.94) 98%,
    rgba(0, 0, 0, 0) 100%
  );
  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 2%,
    rgba(0, 0, 0, 0.94) 98%,
    rgba(0, 0, 0, 0) 100%
  );
}
a, .tr {
  display: flex;
  td {
    flex: 1;
  }
}
.back {
  padding: 5px 0;
}
</style>
